<template>
<div>
    <v-row align="center" justify="center">
        <v-card elevation="2">
            <v-card-title class="ma-0 pa-3">Vehicle Information</v-card-title>
            <v-divider class="mx-4 ma-1"></v-divider>
            <v-form v-if="item" style="margin-left:2%; margin-right:2%">
                <v-row style="height: 50px;">
                    <v-col cols="4">
                        <v-text-field v-model="item.key.make" readonly dense type="text" label="Make:" outlined></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="item.key.model" readonly dense type="text" label="Model:" outlined></v-text-field>
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="item.key.year" readonly dense type="text" label="Year:" outlined></v-text-field>
                    </v-col>
                </v-row>

                <v-row class="ma-0 pa-0">
                    <v-card-text style="margin-left:-2%; margin-top:1%; height:70px;"> System Types:
                        <v-chip-group multiple style="margin-left:16%; margin-right:1%;">
                            <v-chip color="success" text-color="white" v-bind:key="sys.id" v-for="sys in item.sysTypes">
                                {{sys.sysType}}
                            </v-chip>
                        </v-chip-group>
                    </v-card-text>

                </v-row>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text-color="white" text @click="close">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-row>
</div>
</template>

<script>

export default {
    props: ['item'],
    created() {

    },
    data: () => ({
         
    }),
    methods: {
        close(){
          this.$parent.deleteVeh();
        }
    }
}

</script>
